import { Dashboard } from "./dashboard/Dashboard";
import React from "react";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import { NewItem } from "./create/NewItem";
import { Item } from "./item/Item";
import { Items } from "./list/Items";

export const Component: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} exact>
        <Dashboard />
      </Route>
      <Route path={`${path}/list`} exact>
        <Items />
      </Route>

      <Route path={`${path}/list/new`} exact>
        <NewItem />
      </Route>

      <Route path={`${path}/list/:id`}>
        <Item />
      </Route>
    </Switch>
  );
};
